import { isSSR } from '@sajari/react-sdk-utils';

var priceRangePattern = /\d+\s-\s\d+/gm;
var patternTest = /*#__PURE__*/priceRangePattern.test.bind(priceRangePattern);
var collator = /*#__PURE__*/new Intl.Collator(! /*#__PURE__*/isSSR() ? window.navigator.language : 'en-US', {
  numeric: true
});

var sortComparitor = function sortComparitor(byLabel, asc) {
  return function (_ref, _ref2) {
    var labelLeft = _ref[0],
        valueLeft = _ref[1];
    var labelRight = _ref2[0],
        valueRight = _ref2[1];
    var left = String(byLabel ? labelLeft : valueLeft);
    var right = String(byLabel ? labelRight : valueRight);

    switch (true) {
      case [left, right].every(patternTest):
        {
          var minLeft = left.split(' - ').map(Number)[0];
          var minRight = right.split(' - ').map(Number)[0];

          if (asc) {
            return collator.compare(String(minLeft), String(minRight));
          }

          return collator.compare(String(minRight), String(minLeft));
        }

      case left.startsWith('>'):
      case right.startsWith('<'):
        return asc ? 1 : -1;

      case left.startsWith('<'):
      case right.startsWith('>'):
        return asc ? -1 : 1;
    }

    if (asc) {
      return collator.compare(String(left), String(right));
    }

    return collator.compare(String(right), String(left));
  };
};

var sortItems = function sortItems(list, sort, asc) {
  if (sort === void 0) {
    sort = 'alpha';
  }

  if (asc === void 0) {
    asc = true;
  }

  if (sort === 'none') {
    return list;
  }

  var byLabel = sort !== 'count';
  return list.sort(sortComparitor(byLabel, asc));
};
var sortOptions = function sortOptions(list, sort, asc) {
  if (sort === void 0) {
    sort = 'alpha';
  }

  if (asc === void 0) {
    asc = true;
  }

  if (sort === 'none') {
    return list;
  }

  var byLabel = sort !== 'count';
  return list.sort(function (_ref3, _ref4) {
    var labelLeft = _ref3.label,
        valueLeft = _ref3.count;
    var labelRight = _ref4.label,
        valueRight = _ref4.count;
    return sortComparitor(byLabel, asc)([labelLeft, valueLeft], [labelRight, valueRight]);
  });
};
var filterItems = function filterItems(list, _ref5) {
  var excludes = _ref5.excludes,
      includes = _ref5.includes,
      prefixFilter = _ref5.prefixFilter;

  if (!includes && !excludes && !prefixFilter) {
    return list.map(function (_ref6) {
      var value = _ref6[0],
          count = _ref6[1];
      return {
        value: value,
        count: Number(count),
        label: value
      };
    });
  }

  var filteredList = [];

  for (var current = 0; current < list.length; current++) {
    var _list$current = list[current],
        value = _list$current[0],
        count = _list$current[1];
    var add = true;
    add = !excludes || !excludes.includes(value);
    add = add && (!includes || includes.includes(value));

    if (add) {
      filteredList.push({
        value: value,
        count: Number(count),
        label: value
      });
    }
  }

  if (prefixFilter) {
    filteredList = filteredList.filter(function (_ref7) {
      var value = _ref7.value;
      return value.startsWith(prefixFilter);
    }).map(function (_ref8) {
      var value = _ref8.value,
          count = _ref8.count;
      return {
        label: value.replace(prefixFilter, ''),
        count: count,
        value: value
      };
    });
  }

  return filteredList;
};

export { filterItems, sortItems, sortOptions };
//# sourceMappingURL=utils.esm.js.map
